import http from '../../../../api/http';
import type { Rol, Permiso } from '../types/usuario.types';

export const rolService = {
  async getAll(): Promise<Rol[]> {
    const response = await http.get('/rol');
    return response.data;
  },

  async getById(id: number): Promise<Rol> {
    const response = await http.get(`/rol/${id}`);
    return response.data;
  },

  async save(rol: Rol): Promise<Rol> {
    if (rol.id === 0) {
      const response = await http.post('/rol', rol);
      return response.data;
    } else {
      const response = await http.put(`/rol/${rol.id}`, rol);
      return response.data;
    }
  },

  async delete(id: number): Promise<void> {
    await http.delete(`/rol/${id}`);
  },

  async asignarPermisos(idRol: number, idsPermisos: number[]): Promise<void> {
    await http.post(`/rol/${idRol}/permisos`, idsPermisos);
  },

  async getPermisos(idRol: number): Promise<Permiso[]> {
    const response = await http.get(`/rol/${idRol}/permisos`);
    return response.data;
  }
};
